import { $Q, $Qll } from "graditify-utils"

/**
 * Validate last element focused, when the last element is blur, it focus submit button
 * @param {node} currentInput - Current input focused
 * @param {array} arrayInputs - Array of inputs
 */
const focusSubmitBtn = (currentInput, arrayInputs) => {
  if (currentInput.name === arrayInputs[arrayInputs.length - 1].name) {
    arrayInputs[arrayInputs.length - 1].addEventListener('blur', () => {
      const btn = $Q('#js-filter-form-submit-desktop')

      if (btn) {
        btn.focus()
      }
    })
  }
}

/**
 * Add listener for elements focused.
 * Filter range and disabled inputs
 * @see focusSubmitBtn
 * @param {boolean} status - If filter menu is enable or disable
 * @returns
 */
export const focusMenu = (status) => {
  if (!status) return

  let inputs = $Qll('.filter-form input')

  inputs = inputs
    .filter((input) => input.type !== 'range')
    .filter((input) => !input.disabled)

  inputs.forEach((input, i, array) => {
    input.addEventListener('focus', (e) => {
      const currentInput = e.target

      focusSubmitBtn(currentInput, array)
    })
  })
}
